import {Auth} from "@/js/caller";

export function StatusList() {
  const isT = Auth.IsTeacher();
  return [
    {value: "", text: "aucun"},
    isT ? "envoyé" : "à faire",
    isT ? "à corriger" : "fini",
    "corrigé"
  ]
}